import React from 'react'
import LowStockTip from 'app/React/ProductForm/LowStockTip'
import 'react-tippy/dist/tippy.css'
import { Tooltip } from 'react-tippy'

function LowStockTippy ({stock = 0}) {

  return (
    <Tooltip
      position={'bottom'}
      theme={'light'}
      html={ <LowStockTip stock={stock}/> }
    >
    <span className={'low_stock'}/>
    </Tooltip>
  )
}

export default LowStockTippy